import React, { useState } from "react";
import PropTypes from "prop-types";

const Sidebar = ({ isOpen, response }) => {
  const [zoomLevel, setZoomLevel] = useState(1);

  const sidebarStyle = {
    height: "100%",
    width: "550px",
    top: 70,
    position: "fixed",
    right: isOpen ? "0" : "-350px",
    backgroundColor: "white",
    overflowX: "scroll",
    transition: "0.2s",
    zIndex: 999,
  };

  const iframeStyle = {
    height: "100%",
    width: "100%",
    border: "none",
    transform: `scale(${zoomLevel})`,
    transformOrigin: "top left",
  };

  const getExtension = (base64Data) => {
    const decodedString = atob(base64Data);

    if (decodedString.startsWith("%PDF-")) {
      return "pdf";
    }

    if (
      decodedString.startsWith("\x89PNG") ||
      decodedString.startsWith("\xFF\xD8\xFF\xE0") ||
      decodedString.startsWith("\xFF\xD8\xFF\xDB")
    ) {
      return "image";
    }
  };

  const handleZoomIn = () => {
    if (zoomLevel < 2) {
      setZoomLevel(zoomLevel + 0.1);
    }
  };

  const handleZoomOut = () => {
    if (zoomLevel > 0.5) {
      setZoomLevel(zoomLevel - 0.1);
    }
  };

  return (
    <>
      <div style={sidebarStyle}>
        <div
          style={{
            height: "100vh",
            width: "auto",
            overflow: "hidden",
            position: "relative",
          }}
        >
          <iframe
            src={
              getExtension(response) === "pdf"
                ? `data:application/pdf;base64,` + response
                : `data:image/png;base64,` + response
            }
            style={iframeStyle}
            title="Content Frame"
          />
          <div
            style={{
              textAlign: "center",
              marginTop: "10px",
              position: "absolute",
              top: "550px",
              right: "150px",
            }}
          >
            <button
              className="btn btn-sm btn-primary me-2"
              onClick={handleZoomIn}
            >
              Zoom In
            </button>
            <button className="btn btn-sm btn-primary" onClick={handleZoomOut}>
              Zoom Out
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

Sidebar.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  response: PropTypes.string.isRequired,
};

export default Sidebar;
